import { useEffect, useMemo } from "react";

import useWellnessPlans from "./useWellnessPlans";

/**
 * Lowest monthly and annual plan prices in a pet's catalog — powers the
 * "starting at $X/month" and "starting at $X a year" clauses on the
 * prequalification result screens.
 *
 * @param {string | undefined} petId Pet whose catalog to price;
 * @return {object} Object with monthly and annual min prices (or null).
 */
export const useMinPlanPrices = (petId?: string) => {
  const { fetchCatalogItems, planPricing } = useWellnessPlans();

  useEffect(() => {
    if (petId) {
      fetchCatalogItems(petId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [petId]);

  return useMemo(() => {
    const entries = Object.values(planPricing);
    const monthlyPrices = entries.map((p) => p.monthly).filter((v) => v > 0);
    const annualPrices = entries.map((p) => p.annual).filter((v) => v > 0);

    return {
      monthly: monthlyPrices.length ? Math.min(...monthlyPrices) : null,
      annual: annualPrices.length ? Math.min(...annualPrices) : null,
    };
  }, [planPricing]);
};
